import { Box, Skeleton } from '@mui/material';

export const BannerPlaceholder = () => {
  return (
    <Box
      sx={{
        width: '100%',
        paddingBottom: '20%',
        overflow: 'hidden',
        position: 'relative',
      }}
    >
      <Skeleton
        variant='rectangular'
        width='100%'
        height='100%'
        sx={{ position: 'absolute', top: 0, left: 0 }}
      />
    </Box>
  );
};
